import OrderMethodModal from './order-method-modal-controller'

export default OrderMethodModal
